import styled from 'styled-components'

// @TODO move up (?)
const defaultColor = 'rgba(20, 158, 252, 1)'

/**
 * @typedef {Object} ButtonLoaderProps
 * @property {string} [dataTestElement]
 * @property {string} [color]
 */

/** @type {import('styled-components').StyledComponent<'span', any, ButtonLoaderProps>} */
const ButtonLoaderUi = styled.span.attrs(props => ({
  'data-test-element': props.dataTestElement || '',
}))`
  float: left;
  margin: ${p => p.margin || '2px 8px 0 0'};
  display: inline-block;
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid ${p => p.color ?? defaultColor};
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default ButtonLoaderUi
